import { FormattedMessage } from 'react-intl';

import ErrorScreen from './ErrorScreen';

const NoBookingsScreen = () => {
  return (
    <ErrorScreen
      text={
        <FormattedMessage
          id="account_v2.homepage.filter_trips.no_bookings.text"
          defaultMessage="We didn't find any trips matching your search criteria."
        />
      }
      title={
        <FormattedMessage
          id="account_v2.homepage.filter_trips.no_bookings.title"
          defaultMessage="No results found"
        />
      }
      dataTest="NoBookingsFound"
    />
  );
};

export default NoBookingsScreen;
